























import { Component, Prop, Vue } from 'vue-property-decorator';

class StepInfo {
  title: string;
  code: string;
  step: number;
  status: string;
  isCurrent: boolean;

  constructor(title: string, code: string, step: number, status: string, isCurrent = false) {
    this.title = title;
    this.code = code;
    this.step = step;
    this.status = status;
    this.isCurrent = isCurrent;
  }
}

@Component({
  components: {
  }
})
export default class Pipeline extends Vue {
  private steps: Array<StepInfo>;

  constructor() {
    super();
    this.steps = new Array<StepInfo>();
    let index = 0;
    this.steps.push(new StepInfo('模型转化', 'ModelConvert', index++, 'success'));
    this.steps.push(new StepInfo('代码生成', 'CodeGen', index++, 'success'));
    this.steps.push(new StepInfo('应用发布', 'Publish', index++, 'process', true));
    this.steps.push(new StepInfo('应用编译', 'Compile', index++, 'wait'));
    this.steps.push(new StepInfo('应用部署', 'Deploy', index++, 'wait'));
    this.steps.push(new StepInfo('执行流水线', 'Result', index++, 'wait'));
  }

  mounted() {
    // mounted
  }

  /** 获取当前Step */
  getCurStep(): StepInfo {
    const findStep = this.steps.find(step => step.isCurrent);
    if (findStep) {
      return findStep;
    }
    return this.steps[0];
  }

  /** 获取当前Step */
  getStep(code: string): StepInfo {
    const findStep = this.steps.find(step => step.code === code);
    if (findStep) {
      return findStep;
    }
    return this.steps[0];
  }

  /** 设置当前的步骤 */
  setCurStep(code: string) {
    this.steps.forEach(step => {
      step.isCurrent = step.code === code;
    });
  }
}
